import { useGLTF } from "@react-three/drei";

export const useDracoGLTF = (path: string) => {
  return useGLTF(path, "./draco/gltf/");
};

useDracoGLTF.preload = (path: string) => useGLTF.preload(path, "./draco/gltf/");
